import { ReactNode, useState } from "react";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";

interface Props {
  children: ReactNode;
  closedStateText: string; // closedStateText?: string; -> Question mark means it is optional
  openedStateText: string;
  buttonVarient: string;
  buttonStyle?: React.CSSProperties;
  buttonClassName?: string;
}

export const ExpandableComponent: React.FC<Props> = ({
  children,
  closedStateText,
  openedStateText,
  buttonVarient,
  buttonStyle,
  buttonClassName,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={buttonVarient}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls="collapseID"
        style={buttonStyle}
        className={buttonClassName}
      >
        {open ? openedStateText : closedStateText}
      </Button>
      <Collapse in={open}>
        <div
          // id="collapseID"
          style={{
            textAlign: "justify",
            marginTop: "10px",
          }}
        >
          {children}
        </div>
      </Collapse>
    </>
  );
};
